import React, { useState, useEffect } from 'react';

const LoadingScreen = ({ loading = true }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(loading);

  console.log('loading',loading)

  useEffect(() => {
    if (loading) {
      setIsVisible(true);
      const interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + Math.random() * 5;
        });
      }, 200);

      return () => clearInterval(interval);
    } else {
      // When loading becomes false, start fade out
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  // Reset progress when loading starts again
  useEffect(() => {
    if (loading) {
      setProgress(0);
    }
  }, [loading]);



  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: 'black',
      zIndex: 9999,
      opacity: (loading && isVisible) ? 1 : 0,
      visibility: (loading && isVisible) ? 'visible' : 'hidden',
      transition: 'opacity 0.5s ease-out, visibility 0.5s ease-out',
      overflow: 'hidden'
    }}>
      
      

      {/* Main logo container */}
      <div className="mb" style={{marginLeft:"15px",marginTop:"175px"}}> 
          <img style={{height:"110px",width:"110px"}} src="https://api.successguardian.in/media/logo_sg_small.png" ></img>
          <h5> 
          </h5>
        </div>

      {/* Company name */}
     

      {/* Loading text */}
      <div style={{
        fontSize: '16px',
        fontWeight: '300',
        marginBottom: '40px',
        opacity: 0.9,
        animation: 'pulse 2s ease-in-out infinite'
      }}>
        Loading...
      </div>

      {/* Progress bar container */}
      <div style={{
        width: '300px',
        height: '4px',
        background: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '2px',
        overflow: 'hidden',
        marginBottom: '20px',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)'
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          background: 'linear-gradient(90deg, #00CED1, #FFD700, #00CED1)',
          borderRadius: '2px',
          transition: 'width 0.3s ease',
          boxShadow: '0 0 10px rgba(0, 206, 209, 0.5)',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
            animation: 'progressShine 1.5s ease-in-out infinite'
          }} />
        </div>
      </div>

      {/* Progress percentage */}
      <div style={{
        fontSize: '14px',
        fontWeight: '300',
        opacity: 0.8,
        marginBottom: '30px'
      }}>
        {Math.round(progress)}%
      </div>

      {/* Loading dots */}
      <div style={{
        display: 'flex',
        gap: '8px'
      }}>
        {[0, 1, 2].map((i, index) => (
          <div
            key={index}
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              background: '#123abc',
              animation: `loadingDots 1.4s ease-in-out infinite`,
              animationDelay: `${i * 0.16}s`
            }}
          />
        ))}
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes logoFloat {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(1deg); }
          66% { transform: translateY(-5px) rotate(-1deg); }
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }

        @keyframes textGlow {
          0% { text-shadow: 0 0 20px rgba(255, 255, 255, 0.5); }
          100% { text-shadow: 0 0 30px rgba(255, 255, 255, 0.8), 0 0 40px rgba(0, 206, 209, 0.3); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.7; }
          50% { opacity: 1; }
        }

        @keyframes progressShine {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        @keyframes loadingDots {
          0%, 80%, 100% { transform: scale(0.8); opacity: 0.5; }
          40% { transform: scale(1.2); opacity: 1; }
        }

        @keyframes particleMove {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-20px) rotate(2deg); }
          66% { transform: translateY(-10px) rotate(-2deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;